<template>
  <div class="news-list">
    <b-row class="m-0 text-center instance">
      <b-col class="newsGutter pb-1 " sm="12" md="4" xl="4" v-for="(item,index) in searchData" @click="toDetail(item)" :key="index">
        <div class="img_cover_box news-height">
            <div class="img-cover">
          </div>
          <img
            class="d-block img-fluid w-100 img_h"
            width="1024"
            height="490"
            v-if="item.sourceUrl"
            :src="item.sourceUrl"
            alt=""
          />
        </div>
        <div class="innerbox">
          <div
            class="instance-txt"
          > 
          <i class="vedio_icon" v-if="item.type == '视频'"></i>
          {{item.postTitle}}</div>
          <span class="text-uppercase metro-btn">{{item.category}}</span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "NewsList",
  props: ["searchData"],
  mounted() {
    this.handelWidth();
    // this.handelImg();            //采用缩略图
  },
  methods: {
    handelImg() {
      this.searchData.forEach((item, index) => {
        var alllength = item.sourceUrl.length;
        var pointlength = item.sourceUrl.lastIndexOf(".");
        var str1 = item.sourceUrl.substr(0, pointlength);
        var str2 = item.sourceUrl.substr(pointlength, alllength);
        var newStr;
        newStr = str1 + "_related" + str2;
        this.searchData[index].sourceUrl = newStr;
      });
    },
    handelWidth() {
      // console.log('newList')
      var container = document.getElementsByClassName("news-height");
      var img_h = document.getElementsByClassName("news-height");

      this.playerHeight = container[0].clientWidth / (16 / 9) + "px";
      for (var i = 0; i < container.length; i++) {
        container[i].style.height = this.playerHeight;
        img_h[i].style.height = this.playerHeight;
        // console.log(container[i].style.height);
      }
    },
    toDetail(item) {
      this.$router
        .push({
          path: "/detail",
          query: {
            postId: item.postId,
          },
        })
        .catch(err => {
          err;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.news-list {
  clear: both;
  overflow-x: hidden;
  .instance {
    font-size: 36px;
    .newsGutter {
      // padding-top: 0.3rem;
      cursor: pointer;
      .img_cover_box {
        overflow: hidden;
        position: relative;
        background: url("../../../assets/imgs/home/bg_img.jpg");
        background-size: contain;
      }
      .img_cover_box:hover {
        // background: rgba(0, 0, 0, 0.3);
        opacity: 0.9;
      }
      .img_h {
        // height: 3rem;
        width: 100%;
        height: 100%;
      }
    }

    position: relative;
    color: #ffffff;
    .innerbox {
      width: calc(100% - 0.4rem);
      margin: 0 0.2rem;
      // font-size: 0.3rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .instance-txt {
        width: calc(100% - 0.4rem);
        font-size: 22px;
        line-height: 32px;
        white-space: pre-line;
      }
      .instance-txt:hover {
        color: #01a2dd;
      }
      .vedio_icon {
        display: inline-block;
        // height: 0.6rem;
        // width: 0.6rem;
        background: url("~@/assets/imgs/home/vedio_icon.png") no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .metro-btn {
        position: relative;
        // top: 0.3rem;
        border: 1px solid #ffffff;
        // padding: 0.1rem;
        padding: 4px 3px 2px 5px;
        cursor: pointer;
        font-size: 0.2rem;
        margin-right: 5px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .news-list {
    clear: both;
    overflow: hidden;
    .instance {
      .innerbox {
        .instance-txt {
          width: calc(100% - 0.4rem);
          font-size: 20px;
          line-height: 24px;
        }
      }
      .newsGutter {
        padding: 0 !important;
        .img_cover_box {
          height: 5.5rem;
          overflow: hidden;
        }
        .img_h {
          width: 100%;
          // height: 100%;
          height: auto;

          // height: 100% !important;
          // width: auto !important;
        }
      }
      .instance-txt {
        // font-size: 20px;
      }
    }
  }
  .pagination {
    display: none;
  }
}
@media screen and (min-width: 768px) {
  .news-list {
    min-height: 5rem;
  }
  //  style="min-height:5rem"
  .metro-btn {
    display: none;
  }
  .pagination {
    height: 0.6rem;
  }
  .pagination {
    display: block;
  }
  .vedio_icon {
    display: inline-block;
    height: 20px;
    width: 20px;
    background: url("../../../assets/imgs/home/vedio_icon.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    position: relative;
    top: 0.01rem;
  }
}
</style>